import { Fade } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import cn from "classnames";
import { ISidebarListItemProps } from "./SidebarListItem.props";
import styles from "./SidebarListItem.module.scss";

const SidebarListItem = ({ itemName, itemId, selectedItem, additionalIcon = <></>, smallSize = false, ...props }: ISidebarListItemProps): JSX.Element => {
	const { children, ...rest } = props;

	return (
		<Fade in={true} timeout={500}>
			<li
				className={cn(styles.li, {
					[styles.liSmallSize]: smallSize,
					[styles.liSelected]: selectedItem === (itemId || itemName),
				})}
				{...(rest as React.HTMLAttributes<HTMLLIElement>)}
			>
				<div className={styles.liContent} id="elementWithTitle" title={itemName}>
					{children}
					<span className={styles.liName}>{itemName.replace(/\r|\n/, " ")}</span>
					{additionalIcon}
				</div>
				{selectedItem === (itemId || itemName) && <FontAwesomeIcon icon={faAngleRight} />}
			</li>
		</Fade>
	);
};

export default SidebarListItem;
